"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeExcludedFields = exports.removeExtraData = exports.FIELD_IS_EMPTY = exports.MAX_EXTRA_DATA_LENGTH = exports.EXCLUDE_STORE_KEYS_BY_DEFAULT = void 0;

var _jsonStringifySafe = _interopRequireDefault(require("json-stringify-safe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EXCLUDE_STORE_KEYS_BY_DEFAULT = ['trl', 'areaTree', 'profareaTree', 'industriesTree', 'professionalRoleTree'];
exports.EXCLUDE_STORE_KEYS_BY_DEFAULT = EXCLUDE_STORE_KEYS_BY_DEFAULT;
var MAX_EXTRA_DATA_LENGTH = 1024 * 200;
exports.MAX_EXTRA_DATA_LENGTH = MAX_EXTRA_DATA_LENGTH;
var FIELD_IS_EMPTY = 'FIELD_IS_EMPTY';
exports.FIELD_IS_EMPTY = FIELD_IS_EMPTY;

var getTrlLength = function getTrlLength(event) {
  var _event$extra, _event$extra$state;

  return event !== null && event !== void 0 && (_event$extra = event.extra) !== null && _event$extra !== void 0 && (_event$extra$state = _event$extra.state) !== null && _event$extra$state !== void 0 && _event$extra$state.trl ? JSON.stringify(event.extra.state.trl).length : 0;
};

var removeExtraData = function removeExtraData(event) {
  // Не отсылаем ошибку, если в extra слишком много информации, см. https://jira.hh.ru/browse/HH-69844
  var extraDataLength = (0, _jsonStringifySafe.default)(event.extra).length;

  if (extraDataLength > MAX_EXTRA_DATA_LENGTH) {
    var _event$extra$state$re, _event$extra2, _event$extra2$state, _event$extra$state$lo, _event$extra3, _event$extra3$state, _event$extra$state$la, _event$extra4, _event$extra4$state;

    event.extra = {
      baseStateSelectors: {
        request: (_event$extra$state$re = (_event$extra2 = event.extra) === null || _event$extra2 === void 0 ? void 0 : (_event$extra2$state = _event$extra2.state) === null || _event$extra2$state === void 0 ? void 0 : _event$extra2$state.request) !== null && _event$extra$state$re !== void 0 ? _event$extra$state$re : FIELD_IS_EMPTY,
        locale: (_event$extra$state$lo = (_event$extra3 = event.extra) === null || _event$extra3 === void 0 ? void 0 : (_event$extra3$state = _event$extra3.state) === null || _event$extra3$state === void 0 ? void 0 : _event$extra3$state.locale) !== null && _event$extra$state$lo !== void 0 ? _event$extra$state$lo : FIELD_IS_EMPTY,
        langs: (_event$extra$state$la = (_event$extra4 = event.extra) === null || _event$extra4 === void 0 ? void 0 : (_event$extra4$state = _event$extra4.state) === null || _event$extra4$state === void 0 ? void 0 : _event$extra4$state.langs) !== null && _event$extra$state$la !== void 0 ? _event$extra$state$la : FIELD_IS_EMPTY
      },
      __removed: 'Extra data is removed due to exceeding maximum stringified length ('.concat(extraDataLength, "/").concat(MAX_EXTRA_DATA_LENGTH, ")")
    };
  }
};

exports.removeExtraData = removeExtraData;

var removeExcludedFields = function removeExcludedFields(event) {
  var excludeStoreKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EXCLUDE_STORE_KEYS_BY_DEFAULT;

  if (event.extra.state) {
    event.extra.state = _objectSpread({}, event.extra.state);
    event.extra.trlsLength = getTrlLength(event);
    excludeStoreKeys.forEach(function (key) {
      event.extra.state[key] = '[removed]';
    });
  }
};

exports.removeExcludedFields = removeExcludedFields;